import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import BookmakerLink from '../bookmakerLink';
import TopUpForm from './components/TopUpForm';
import CardNumberError from './components/CardNumberError';
import { create as createLogger } from '../utils/logger';

const logger = createLogger('TopUp');

class TopUp extends Component {

    componentWillMount() {
        const {
            apiName,
            getCardDetails,
            feed,
            isTopUpIntegrated,
        } = this.props;

        if (isTopUpIntegrated) {
            getCardDetails(apiName, feed);
        }
    }

    submitTopUp = ({ cv2, amount }) => {
        const { apiName, getUserInfo, feed, cardDetails } = this.props;
        const cardNum = cardDetails && cardDetails.cleanCardNumber;
        return this.props.topUpAccountBalance(apiName, cv2, amount, cardNum)
            .then(() => getUserInfo(apiName, feed))
            .catch(err => logger.error(err));
    }

    render() {
        const {
            isTopUpIntegrated,
            isCardDetailsError,
            topUpBookmakerUrl,
            topUpBookmakerName,
            topUpPhoneNumber,
            isPhone,
            currencySign,
            cardDetails,
        } = this.props;
        const cardNumber = cardDetails && cardDetails.cardNumber;
        if (!isTopUpIntegrated) {
            return (
                <BookmakerLink
                    titleText={`To deposit, please visit ${topUpBookmakerName}`}
                    bookmakerUrl={topUpBookmakerUrl}
                    bookmakerName={topUpBookmakerName}
                />
            );
        }

        return (
            <React.Fragment>
                {
                    isCardDetailsError || !cardDetails || !cardDetails.cardId ? (
                        <CardNumberError
                            topUpUrl={topUpBookmakerUrl}
                            topUpBookmakerName={topUpBookmakerName}
                            topUpPhoneNumber={topUpPhoneNumber}
                            isPhone={isPhone}
                        />
                    ) : (
                        <TopUpForm
                            currencySign={currencySign}
                            cardNumber={cardNumber}
                            onSubmit={this.submitTopUp}
                        />
                    )
                }
            </React.Fragment>
        );
    }
}

TopUp.defaultProps = {
    cardDetails: null,
    isCardDetailsError: false,
    topUpBookmakerUrl: '',
    topUpBookmakerName: '',
    topUpPhoneNumber: '',
    isTopUpModalVisible: false,
    isTopUpIntegrated: false,
    topUpErrorInfo: null,
}

TopUp.propTypes = {
    apiName: PropTypes.string.isRequired,
    feed: PropTypes.string.isRequired,
    cardDetails: PropTypes.shape({
        cardId: PropTypes.cardId,
        cardNumber: PropTypes.string,
    }),
    isTopUpIntegrated: PropTypes.bool.isRequired,
    isCardDetailsError: PropTypes.bool,
    topUpBookmakerUrl: PropTypes.string,
    topUpBookmakerName: PropTypes.string,
    topUpPhoneNumber: PropTypes.string,
    isPhone: PropTypes.bool.isRequired,
    currencySign: PropTypes.string.isRequired,
    getUserInfo: PropTypes.func.isRequired,
    topUpAccountBalance: PropTypes.func.isRequired,
    getCardDetails: PropTypes.func.isRequired,
}

export default TopUp;



// WEBPACK FOOTER //
// /src/js/common/topUp/TopUp.jsx